import React, { Component } from "react";

import {
  Card,
  Button,
  Table,
  Tooltip,
  Select,
  Input,
  BackTop,
  Checkbox,
  Tag,
} from "antd";

import { connect } from "react-redux";
import { req_page_ila_student, req_downloadfile_ila_student } from "../../api";

import {
  API_BASE,
  PAGE_SIZE,
  SORT_FIELD_NAME,
  SORT_UP_DOWN,
} from "../../utils/contrains";
import { usrRole } from "../../utils/dataUtil";
import {
  getNowAcademicYear,
  getNowAcademicSemester,
} from "../../utils/dateUtil";

class ILAStudentList extends Component {
  // 基礎通用參數 //////////////////////////////////////////////
  state = {
    deviceWidth: 0,
    loading: false,
    userLevel: "NORMAL",
    items: [],
    item: {},
    pagination: {
      current: 1,
      pageSize: PAGE_SIZE,
      total: 0,
    },
    columnSort: SORT_FIELD_NAME,
    orderBy: SORT_UP_DOWN,
    searchField: "NONE",
    searchValue: "",
    filterStatus: "",

    domnloadFile: "",

    preUndone: "NO",
    postUndone: "NO",

    nowAcademicYear: getNowAcademicYear(new Date()),
    nowAcademicSemester: getNowAcademicSemester(new Date()),
  };

  UNSAFE_componentWillMount() {
    this.init_columns();
  }

  componentDidMount() {
    window.addEventListener("resize", this.resize.bind(this));
    this.resize();
    this.api_page_items(1);
  }

  // 遠端數據處理 //////////////////////////////////////////////

  api_page_items = async (current) => {
    const { pageSize } = this.state.pagination;
    const {
      searchField,
      searchValue,
      columnSort,
      orderBy,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      preUndone,
      postUndone,
    } = this.state;
    const { token, userCode, role } = this.props.user;
    var userLevel = usrRole(role);
    this.setState({ userLevel: userLevel });

    this.setState({ loading: true, items: [] });
    const result = await req_page_ila_student(
      userCode,
      userLevel,
      nowAcademicYear,
      nowAcademicSemester,
      current,
      pageSize,
      columnSort,
      orderBy,
      searchField,
      searchValue,
      filterStatus,
      preUndone,
      postUndone,
      token
    );
    this.setState({ loading: false });

    //console.log(result)
    if (result.total > 0) {
      const { total } = result;
      const items = result.data;
      const pagination = {
        current: this.current,
        pageSize: this.state.pagination.pageSize,
        total,
      };
      this.setState({ items, pagination });
      //console.log(this.state);
    } else {
      const items = [];
      const pagination = {
        current: 1,
        pageSize: this.state.pagination.pageSize,
        total: 0,
      };
      this.setState({ items, pagination });
    }
  };

  api_downloadfile_items = async () => {
    const {
      userLevel,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      preUndone,
      postUndone,
    } = this.state;
    const { token, userCode } = this.props.user;

    const fileUrl = await req_downloadfile_ila_student(
      userLevel,
      userCode,
      searchField,
      searchValue,
      filterStatus,
      nowAcademicYear,
      nowAcademicSemester,
      preUndone,
      postUndone,
      token
    );

    // download file link
    let a = document.createElement("a");
    a.href = API_BASE + fileUrl;
    a.target = "_blank";
    a.download = "清單";
    a.click();
  };

  // 數據配置設定 //////////////////////////////////////////////

  init_columns = () => {
    const nowAcademicYear = getNowAcademicYear(new Date());
    const nowAcademicSemester = getNowAcademicSemester(new Date());
    this.setState({ nowAcademicYear, nowAcademicSemester });
    this.columns = [
      {
        title: "學年度/學期",
        width: 16,
        responsive: ["md"],
        render: (row) => {
          const { AcademicYear, Semester } = row;
          return (
            <div className="text-center">
              <span style={{ fontSize: "1.3em" }}>
                {" "}
                {AcademicYear} / {Semester}
              </span>
            </div>
          );
        },
      },
      {
        title: "開課班級",
        dataIndex: "OpenClassName",
        width: 30,
      },
      {
        title: "學號",
        dataIndex: "StudentId",
        width: 20,
      },
      {
        title: "姓名",
        dataIndex: "TwName",
        width: 25,
      },
      {
        title: "前測分數",
        width: 20,
        render(record) {
          return {
            props: {
              style: {
                background:
                  record.PreScore > 59 ? "palegreen" : "lavenderblush",
              },
            },
            children: (
              <div
                title={record.PreScore}
                style={{
                  color: record.PreScore > 59 ? "green" : "red",
                  fontWeight: "Bold",
                }}
              >
                <div className="text-center">
                  {" "}
                  {record.PreScore === -1 ? (
                    <Tag color="warning">
                      <span style={{ fontSize: "1.3em" }}> 未施測</span>
                    </Tag>
                  ) : (
                    record.PreScore
                  )}
                </div>
              </div>
            ),
          };
        },
      },
      {
        title: "後測分數",
        width: 20,
        render(record) {
          return {
            props: {
              style: {
                background:
                  record.PostScore > 59 ? "palegreen" : "lavenderblush",
              },
            },
            children: (
              <div
                title={record.PreScore}
                style={{
                  color: record.PostScore > 59 ? "green" : "red",
                  fontWeight: "Bold",
                }}
              >
                <div className="text-center">
                  {" "}
                  {record.PostScore === -1 ? (
                    <Tag color="warning">
                      <span style={{ fontSize: "1.3em" }}> 未施測</span>
                    </Tag>
                  ) : (
                    record.PostScore
                  )}
                </div>
              </div>
            ),
          };
        },
      },
    ];
  };

  // 操作互動處理 //////////////////////////////////////////////

  resize() {
    this.setState({ deviceWidth: window.innerWidth });
  }

  handle_page_size_change = (current, size) => {
    //console.log(size)
    this.setState(
      {
        pagination: {
          current: current,
          pageSize: size,
        },
      },
      () => {
        this.api_page_items(current);
      }
    );
  };

  handle_table_change = (pagination, filters, sorter, extra) => {
    if (filters) {
      const status = [...Object.values(filters).filter(Boolean)][0];
      if (status) {
        this.setState({ filterStatus: status }, () => {
          this.api_page_items(pagination.current);
        });
      } else {
        this.setState({ filterStatus: "" }, () => {
          this.api_page_items(pagination.current);
        });
      }
    } else {
      this.api_page_items(pagination.current);
    }
  };

  handle_data_refresh = () => {
    this.api_page_items(this.current);
  };

  onChangeCheckboxPre = (e) => {
    //console.log(e.target.checked);
    e.target.checked
      ? this.setState({ preUndone: "YES" }, () => {
          this.api_page_items(this.current);
        })
      : this.setState({ preUndone: "NONE" }, () => {
          this.api_page_items(this.current);
        });
  };

  onChangeCheckboxPost = (e) => {
    //console.log(e.target.checked);
    e.target.checked
      ? this.setState({ postUndone: "YES" }, () => {
          this.api_page_items(this.current);
        })
      : this.setState({ postUndone: "NONE" }, () => {
          this.api_page_items(this.current);
        });
  };

  handle_data_download = () => {
    this.api_downloadfile_items();
  };

  /////////////////////////////////////////////////////////////

  render() {
    const {
      loading,
      items,
      pagination,
      searchField,
      searchValue,
      nowAcademicYear,
      nowAcademicSemester,
    } = this.state;
    const title = (
      <>
        <Input
          placeholder="學年"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicYear}
          onChange={(event) =>
            this.setState({ nowAcademicYear: event.target.value })
          }
        />
        <Input
          placeholder="學期"
          style={{ width: 55, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={nowAcademicSemester}
          onChange={(event) =>
            this.setState({ nowAcademicSemester: event.target.value })
          }
        />
        <Select
          value={searchField}
          style={{ width: 120, backgroundColor: "LightCyan" }}
          onChange={(value) => this.setState({ searchField: value })}
        >
          <Select.Option value="NONE">搜索條件</Select.Option>
          <Select.Option value="OpenClassName">開課班級</Select.Option>
          <Select.Option value="TwName">學生姓名</Select.Option>
          <Select.Option value="StudentId">學生學號</Select.Option>
        </Select>
        <Input
          placeholder="關鍵字"
          style={{ width: 80, margin: "0 5px", backgroundColor: "LightYellow" }}
          value={searchValue}
          onChange={(event) =>
            this.setState({ searchValue: event.target.value })
          }
        />
        <Button type="primary" onClick={() => this.api_page_items(1)}>
          <i className="fas fa-search element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>查詢</span>
        </Button>{" "}
        <Tooltip placement="top" title="重新整理">
          <Button type="primary" onClick={() => this.handle_data_refresh()}>
            <i className="fas fa-sync-alt"></i>
          </Button>
        </Tooltip>{" "}
        <Button type="primary" onClick={() => this.handle_data_download()}>
          <i className="fas fa-cloud-download-alt element-hidden"></i>
          <span style={{ marginLeft: "4px" }}>下載</span>
        </Button>
        <p />
        <Checkbox
          onChange={this.onChangeCheckboxPre}
          style={{
            margin: "0 0 5px 5px",
            color: "blue",
            fontWeight: "bold",
          }}
        >
          篩選出未前測者
        </Checkbox>
        <Checkbox
          onChange={this.onChangeCheckboxPost}
          style={{
            margin: "0 0 5px 5px",
            color: "blue",
            fontWeight: "bold",
          }}
        >
          篩選出未後測者
        </Checkbox>
        <span style={{ fontSize: "0.8em", color: "red" }}>
          <i className="fa fa-exclamation" style={{ marginRight: "4px" }}></i>
          每一小時自Google表單接收測驗結果
        </span>
      </>
    );
    return (
      <Card title={title}>
        <Table
          bordered
          scroll={{ y: 480 }}
          loading={loading}
          rowKey="ScoreKey"
          dataSource={items}
          onChange={this.handle_table_change}
          pagination={{
            ...pagination,
            responsive: true,
            showQuickJumper: true,
            showSizeChanger: true,
            pageSizeOptions: [5, 10, 20, 50, 100],
            // onChange: this.api_page_applycase,
            onShowSizeChange: this.handle_page_size_change,
          }}
          columns={this.columns}
        />
        <BackTop visibilityHeight="80" />
      </Card>
    );
  }
}

export default connect((state) => ({ user: state.user }), {})(ILAStudentList);
